import axios from "axios";

export async function addLineWorks(entity) {
	if (entity.getLineType() === "dxf") {
		const json = await fetchDXF(entity.getId());
		await window["viewer"].addDXFFromJSON(entity.getId(), json);
	}
}

async function fetchDXF(dxfId) {
	const res = await axios.get(
		`${import.meta.env.VITE_API_BASE}/lineworks/polylines/${dxfId}`,
	);
	return res.data;
}

export function setLineWorksVisibility(entity, visible) {
	if (entity.getLineType() === "dxf") {
		window["viewer"].setDXFVisibility(entity.getId(), visible);
	}
}

/**
 * API call to create centerline data in DXF format
 * @param {string} lineName - Name of the line
 * @param {Object} centerlineData - Centerline data
 * @param {string | undefined} siteDistanceUnit - Site distance unit
 * @returns {Promise<Response>} - Axios response (blob format)
 */
export async function createCenterlineDXF(
	lineName,
	centerlineData,
	lineId,
	siteDistanceUnit,
) {
	const response = await axios.post(
		`${import.meta.env.VITE_API_BASE}/lineworks/${lineId}/centerline`,
		{
			version: 1,
			data: centerlineData,
			name: lineName || "CenterLine",
			site_distance_unit: siteDistanceUnit,
		},
	);
	return response;
}
